/* unplugin-vue-components disabled */import { render } from "./UserFace.vue?vue&type=template&id=33e7d7b9&scoped=true"
import script from "./UserFace.vue?vue&type=script&lang=js"
export * from "./UserFace.vue?vue&type=script&lang=js"

import "./UserFace.vue?vue&type=style&index=0&id=33e7d7b9&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e7d7b9"]])

export default __exports__